import { useEffect, useState } from "react";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { useDispatch, useSelector } from "react-redux";
import Menu from "../../components/general/Menu";
import TopBar from "../../components/general/TopBar";
import { handleGetUserStats } from "../../state/userStats/actions";
import { fetchUsersByTenant } from "../../state/userStats/reducers";
import { HeadTable } from "./HeadTable";
import { MainTable } from "./MainTable";
import { ContainerCenter, Header, MainContainer, TopDiv } from "./styles";
import ReactLoading from "react-loading";
import { TaskTable } from "./TaskTable";
import { toastAlert } from "../../components/Toastify";
export function UserStats() {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const stats = useSelector((state) => state.userStats);

  const [accUser, setACCUser] = useState(null);

  const [startDate, setStartDate] = useState(
    new Date(new Date().getFullYear(), 0, 1),
  );

  const [finalDate, setFinalDate] = useState(new Date());
  const tenantList = stats.users;

  const { promiseInProgress: statsFetching } = usePromiseTracker({
    area: "get-stats",
  });
  useEffect(() => {
    dispatch(fetchUsersByTenant()).catch((err) => console.log(err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const handleSearch = async () => {
    if (!accUser) {
      toastAlert({
        msg: "É necessário definir um usuário para pesquisar!",
        isError: true,
      });
      return;
    }

    trackPromise(
      dispatch(
        handleGetUserStats(accUser._id, {
          initial: startDate,
          final: finalDate,
        }),
      ).catch((err) => console.log(err)),
      "get-stats",
    );
  };

  return (
    <TopDiv>
      <Menu />
      <MainContainer>
        <TopBar text="Estatísticas de Usuário" />
        <ContainerCenter>
          <Header>
            <HeadTable
              user={[accUser, setACCUser]}
              start={[startDate, setStartDate]}
              final={[finalDate, setFinalDate]}
              userList={tenantList}
              confirmSearch={handleSearch}
            />
          </Header>
          {!statsFetching ? (
            <>
              <MainTable style={{ marginTop: "1.25rem" }} stats={stats} />
              <TaskTable style={{ marginTop: "1.25rem" }} stats={stats} />
            </>
          ) : (
            <div style={{ marginTop: "2rem" }}>
              <ReactLoading type="bars" color="#118052" />
            </div>
          )}
        </ContainerCenter>
      </MainContainer>
    </TopDiv>
  );
}
